// extracted by mini-css-extract-plugin
export default {"input":"T8-z","button":"U8-z","selected":"V8-z","unavailable":"W8-z","oos":"X8-z","image":"Y8-z","paperCutDisabledOverlay":"Z8-z"};